export default {
  history: [],
  list: [],
  total: 0,
  counter: {
    total: 0,
    today: 0,
    week: 0,
    month: 0
  }
};
